import RouterAdmin from "./routes/routes"

const AdminContainer = ({match}) => {
    return (
        <RouterAdmin  match={match}/>
    )
}

export default AdminContainer;